import FeedbackForm from "./FeedbackForm";

const FeedbackPage = () => {
  return (
    <div className="feedback-page">
      <h1>Send Feedback</h1>
      <FeedbackForm />
    </div>
  );
};

export default FeedbackPage;